<template>
  <div>
    <collapse>
      <collapse-item>
        <template slot="title">
          <div class="row">
            <div class="col">
              <h3 class="mb-0">Lotes</h3>
            </div>

            <div class="col text-right pr-5">
              <router-link
                v-if="$can('store', 'plots')"
                :to="{ name: 'PlotCreate', query: { producer: producer } }"
                class="btn btn-outline-success btn-sm"
              >
                <i class="fas fa-seedling"></i>&nbsp;Nuevo Lote
              </router-link>
            </div>
          </div>
        </template>

        <ul class="list-group list-group-flush list my--3">
          <li v-for="plot in plots" :key="plot.id" class="list-group-item px-0">
            <div class="row align-items-center">
              <div class="col">
                <h4 v-if="$can('show', 'plots')" class="mb-2">
                  <router-link :to="{ name: 'PlotShow', params: { id: plot.id } }">
                    {{ plot.name }}
                  </router-link>
                </h4>
                <h4 v-else class="mb-2">{{ plot.name }}</h4>
                <div class="medium mb-2">{{ plot.hectares }} has.</div>
                <div class="small"><span>Variedad:&nbsp; </span>{{ plot.variety.name }}</div>
                <small class="font-italic">{{ plot.campaign.name }}</small>
              </div>
              <div class="col">
                <router-link :to="{ name: canGoToFollowUp(), params: { id: plot.id } }">
                  <badge v-if="plot.preEmergence" class="mb-0" type="primary">
                    <span v-if="plot.harvest">Producción</span>
                    <span v-else-if="plot.emergence">Emergencia</span>
                    <span v-else-if="plot.preEmergence">Pre-Emergencia</span>
                  </badge>
                  <badge v-else class="mb-0" type="danger"> sin seguimiento </badge>
                </router-link>
              </div>
              <div class="col-auto">
                <router-link
                  v-if="$can('show', 'plots')"
                  :to="{ name: 'PlotShow', params: { id: plot.id } }"
                  title="Ver"
                  class="btn base-button btn-outline-info btn-sm"
                >
                  <i class="far fa-eye"></i> VER DETALLES
                </router-link>
              </div>
            </div>
          </li>
          <li v-if="plots.length === 0" class="list-group-item px-0">
            <div class="row align-items-center">
              <div class="col">
                <h4 class="mb-0">Este productor no tiene lotes cargados.</h4>
              </div>
            </div>
          </li>
        </ul>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  name: 'ProducerPlots',
  components: {
    Collapse,
    CollapseItem,
  },

  props: {
    producer: null,
  },

  data() {
    return {
      plots: [],
    };
  },

  created() {
    const parameters = {
      'filter[forProducer]': this.producer,
      include: ['variety', 'campaign', 'harvest', 'emergence', 'preEmergence'],
    };

    this.$services
      .resource('plots')
      .get(parameters)
      .then((res) => res.data.data)
      .then((data) => {
        this.plots = data.plots;
        this.$emit('plotsLoaded', this.getTotalHectares());
      });
  },

  methods: {
    getTotalHectares() {
      return this.plots.reduce((total, plot) => total + plot.hectares, 0);
    },

    canGoToFollowUp() {
      return this.$can('update', 'plots') ? 'PlotFollowUp' : null;
    },
  },
};
</script>
